import apiClient, { extractData } from "./client";

export async function getKpiReport(params = {}) {
  const response = await apiClient.get("/analytics/kpi", { params });
  return extractData(response);
}

export async function getDepartmentsAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/departments", { params });
  return extractData(response);
}

export async function getPayrollAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/payroll", { params });
  return extractData(response);
}

export async function getAttendanceAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/attendance", { params });
  return extractData(response);
}

export async function getDailyAttendanceAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/attendance/daily", {
    params,
  });
  return extractData(response);
}

export async function getComplaintsAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/complaints", { params });
  return extractData(response);
}

export async function getLeavesAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/leaves", { params });
  return extractData(response);
}

export async function getAdvancesAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/advances", { params });
  return extractData(response);
}

export async function getExceptionalAdvancesAnalytics() {
  const response = await apiClient.get("/analytics/advances/exceptional");
  return extractData(response);
}

export async function getDisciplineAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/discipline", { params });
  return extractData(response);
}

export async function getResignationsAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/resignations", { params });
  return extractData(response);
}

export async function getProceduresAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/procedures", { params });
  return extractData(response);
}

export async function getEvaluationsAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/evaluations", { params });
  return extractData(response);
}

export async function getWorkforceAnalytics(params = {}) {
  const response = await apiClient.get("/analytics/workforce", { params });
  return extractData(response);
}

export async function updateBranchManpower(branchId, jobTitle, plannedHeadcount) {
  const response = await apiClient.patch(
    `/analytics/workforce/branches/${branchId}/manpower`,
    { jobTitle, plannedHeadcount },
  );
  return extractData(response);
}

export async function updateDepartmentManpower(
  departmentId,
  jobTitle,
  plannedHeadcount,
) {
  const response = await apiClient.patch(
    `/analytics/workforce/departments/${departmentId}/manpower`,
    { jobTitle, plannedHeadcount },
  );
  return extractData(response);
}

export async function getEmployeeProfilesAnalytics() {
  const response = await apiClient.get("/analytics/employee-profiles");
  return extractData(response);
}
